import { AfterContentInit, Component, ContentChildren, QueryList, ChangeDetectionStrategy } from '@angular/core';
import { AccordionGroupComponent } from '../accordion-group/accordion-group.component';

@Component({
	selector: 'app-accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AccordionComponent implements AfterContentInit {
	@ContentChildren(AccordionGroupComponent)
	groups: QueryList<AccordionGroupComponent>;

	constructor() {}

	ngAfterContentInit(): void {
		const groups = this.groups.toArray();
		if (groups.length === 0) {
			return;
		}

		// Set active to first element
		groups[0].opened = true;
		// Loop through all Groups
		groups.forEach((t) => {
			// when title bar is clicked
			// (toggle is an @output event of Group)
			t.toggle.subscribe(() => {
				// Open the group
				this.openGroup(t);
			});
			/*t.toggle.subscribe((group) => {
        // Open the group
        this.openGroup(group);
      });*/
		});
	}

	/**
	 * Open an accordion group
	 * @param group Group instance
	 */
	openGroup(group: any): void {
		// close other groups
		this.groups.toArray().forEach((t) => (t.opened = false));
		// open current group
		group.opened = true;
	}
}
